var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/i18n"] = t() : (e.wp = e.wp || {}, e.wp.i18n = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      852: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createI18n = void 0;
        var i = n(r(462));
        var o = {
          "": {
            plural_forms: function plural_forms(e) {
              return 1 === e ? 0 : 1;
            }
          }
        },
            a = /^i18n\.(n?gettext|has_translation)(_|$)/;

        t.createI18n = function (e, t, r) {
          var n = new i.default({}),
              s = new Set(),
              notifyListeners = function notifyListeners() {
            s.forEach(function (e) {
              return e();
            });
          },
              doSetLocaleData = function doSetLocaleData(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
            n.data[t] = _objectSpread(_objectSpread(_objectSpread({}, o), n.data[t]), e), n.data[t][""] = _objectSpread(_objectSpread({}, o[""]), n.data[t][""]);
          },
              setLocaleData = function setLocaleData(e, t) {
            doSetLocaleData(e, t), notifyListeners();
          },
              dcnpgettext = function dcnpgettext() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default",
                t = arguments.length > 1 ? arguments[1] : void 0,
                r = arguments.length > 2 ? arguments[2] : void 0,
                i = arguments.length > 3 ? arguments[3] : void 0,
                o = arguments.length > 4 ? arguments[4] : void 0;
            return n.data[e] || doSetLocaleData(void 0, e), n.dcnpgettext(e, t, r, i, o);
          },
              getFilterDomain = function getFilterDomain() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
            return e;
          },
              _x = function _x(e, t, n) {
            var i = dcnpgettext(n, t, e);
            return r ? (i = r.applyFilters("i18n.gettext_with_context", i, e, t, n), r.applyFilters("i18n.gettext_with_context_" + getFilterDomain(n), i, e, t, n)) : i;
          };

          if (e && setLocaleData(e, t), r) {
            var onHookAddedOrRemoved = function onHookAddedOrRemoved(e) {
              a.test(e) && notifyListeners();
            };

            r.addAction("hookAdded", "core/i18n", onHookAddedOrRemoved), r.addAction("hookRemoved", "core/i18n", onHookAddedOrRemoved);
          }

          return {
            getLocaleData: function getLocaleData() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
              return n.data[e];
            },
            setLocaleData: setLocaleData,
            resetLocaleData: function resetLocaleData(e, t) {
              n.data = {}, n.pluralForms = {}, setLocaleData(e, t);
            },
            subscribe: function subscribe(e) {
              return s.add(e), function () {
                return s.delete(e);
              };
            },
            __: function __(e, t) {
              var n = dcnpgettext(t, void 0, e);
              return r ? (n = r.applyFilters("i18n.gettext", n, e, t), r.applyFilters("i18n.gettext_" + getFilterDomain(t), n, e, t)) : n;
            },
            _x: _x,
            _n: function _n(e, t, n, i) {
              var o = dcnpgettext(i, void 0, e, t, n);
              return r ? (o = r.applyFilters("i18n.ngettext", o, e, t, n, i), r.applyFilters("i18n.ngettext_" + getFilterDomain(i), o, e, t, n, i)) : o;
            },
            _nx: function _nx(e, t, n, i, o) {
              var a = dcnpgettext(o, i, e, t, n);
              return r ? (a = r.applyFilters("i18n.ngettext_with_context", a, e, t, n, i, o), r.applyFilters("i18n.ngettext_with_context_" + getFilterDomain(o), a, e, t, n, i, o)) : a;
            },
            isRTL: function isRTL() {
              return "rtl" === _x("ltr", "text direction");
            },
            hasTranslation: function hasTranslation(e, t, i) {
              var o, a;
              var s = t ? t + "" + e : e;
              var u = !(null === (o = n.data) || void 0 === o || null === (a = o[null != i ? i : "default"]) || void 0 === a || !a[s]);
              return r && (u = r.applyFilters("i18n.has_translation", u, e, t, i), u = r.applyFilters("i18n.has_translation_" + getFilterDomain(i), u, e, t, i)), u;
            }
          };
        };
      },
      746: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.subscribe = t.setLocaleData = t.resetLocaleData = t.isRTL = t.hasTranslation = t.getLocaleData = t.default = t._x = t._nx = t._n = t.__ = void 0;
        var n = r(852),
            i = r(149);
        var o = (0, n.createI18n)(void 0, void 0, i.defaultHooks);
        var a = o;
        t.default = a;
        var s = o.getLocaleData.bind(o);
        t.getLocaleData = s;
        var u = o.setLocaleData.bind(o);
        t.setLocaleData = u;
        var l = o.resetLocaleData.bind(o);
        t.resetLocaleData = l;
        var c = o.subscribe.bind(o);
        t.subscribe = c;

        var p = o.__.bind(o);

        t.__ = p;

        var f = o._x.bind(o);

        t._x = f;

        var d = o._n.bind(o);

        t._n = d;

        var _ = o._nx.bind(o);

        t._nx = _;
        var b = o.isRTL.bind(o);
        t.isRTL = b;
        var g = o.hasTranslation.bind(o);
        t.hasTranslation = g;
      },
      648: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = {
          sprintf: !0,
          defaultI18n: !0,
          setLocaleData: !0,
          resetLocaleData: !0,
          getLocaleData: !0,
          subscribe: !0,
          __: !0,
          _x: !0,
          _n: !0,
          _nx: !0,
          isRTL: !0,
          hasTranslation: !0
        };
        Object.defineProperty(t, "__", {
          enumerable: !0,
          get: function get() {
            return a.__;
          }
        }), Object.defineProperty(t, "_n", {
          enumerable: !0,
          get: function get() {
            return a._n;
          }
        }), Object.defineProperty(t, "_nx", {
          enumerable: !0,
          get: function get() {
            return a._nx;
          }
        }), Object.defineProperty(t, "_x", {
          enumerable: !0,
          get: function get() {
            return a._x;
          }
        }), Object.defineProperty(t, "defaultI18n", {
          enumerable: !0,
          get: function get() {
            return a.default;
          }
        }), Object.defineProperty(t, "getLocaleData", {
          enumerable: !0,
          get: function get() {
            return a.getLocaleData;
          }
        }), Object.defineProperty(t, "hasTranslation", {
          enumerable: !0,
          get: function get() {
            return a.hasTranslation;
          }
        }), Object.defineProperty(t, "isRTL", {
          enumerable: !0,
          get: function get() {
            return a.isRTL;
          }
        }), Object.defineProperty(t, "resetLocaleData", {
          enumerable: !0,
          get: function get() {
            return a.resetLocaleData;
          }
        }), Object.defineProperty(t, "setLocaleData", {
          enumerable: !0,
          get: function get() {
            return a.setLocaleData;
          }
        }), Object.defineProperty(t, "sprintf", {
          enumerable: !0,
          get: function get() {
            return i.sprintf;
          }
        }), Object.defineProperty(t, "subscribe", {
          enumerable: !0,
          get: function get() {
            return a.subscribe;
          }
        });
        var i = r(378),
            o = r(852);
        Object.keys(o).forEach(function (e) {
          "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(n, e) || e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function get() {
              return o[e];
            }
          }));
        });

        var a = function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              i = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var o in e) {
            if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
              var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
              a && (a.get || a.set) ? Object.defineProperty(n, o, a) : n[o] = e[o];
            }
          }

          n.default = e, r && r.set(e, n);
          return n;
        }(r(746));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }
      },
      378: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.sprintf = function sprintf(e) {
          try {
            var _o$default;

            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
              r[n - 1] = arguments[n];
            }

            return (_o$default = o.default).sprintf.apply(_o$default, [e].concat(r));
          } catch (t) {
            return t instanceof Error && a("sprintf error: \n\n" + t.toString()), e;
          }
        };
        var i = n(r(593)),
            o = n(r(293));
        var a = (0, i.default)(console.error);
      },
      593: function _(e) {
        e.exports = function memize(e, t) {
          var r,
              n,
              i = 0;

          function memoized() {
            var o,
                a,
                s = r,
                u = arguments.length;

            e: for (; s;) {
              if (s.args.length === arguments.length) {
                for (a = 0; a < u; a++) {
                  if (s.args[a] !== arguments[a]) {
                    s = s.next;
                    continue e;
                  }
                }

                return s !== r && (s === n && (n = s.prev), s.prev.next = s.next, s.next && (s.next.prev = s.prev), s.next = r, s.prev = null, r.prev = s, r = s), s.val;
              }

              s = s.next;
            }

            for (o = new Array(u), a = 0; a < u; a++) {
              o[a] = arguments[a];
            }

            return s = {
              args: o,
              val: e.apply(null, o)
            }, r ? (r.prev = s, s.next = r) : n = s, i === t.maxSize ? (n = n.prev).next = null : i++, r = s, s.val;
          }

          return t = t || {}, memoized.clear = function () {
            r = null, n = null, i = 0;
          }, memoized;
        };
      },
      293: function _(e, t, r) {
        var n;
        !function () {
          "use strict";

          var i = {
            not_string: /[^s]/,
            not_bool: /[^t]/,
            not_type: /[^T]/,
            not_primitive: /[^v]/,
            number: /[diefg]/,
            numeric_arg: /[bcdiefguxX]/,
            json: /[j]/,
            not_json: /[^j]/,
            text: /^[^\x25]+/,
            modulo: /^\x25{2}/,
            placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
            key: /^([a-z_][a-z_\d]*)/i,
            key_access: /^\.([a-z_][a-z_\d]*)/i,
            index_access: /^\[(\d+)\]/,
            sign: /^[+-]/
          };

          function sprintf(e) {
            return sprintf_format(sprintf_parse(e), arguments);
          }

          function vsprintf(e, t) {
            return sprintf.apply(null, [e].concat(t || []));
          }

          function sprintf_format(e, t) {
            var r,
                n,
                o,
                a,
                s,
                u,
                l,
                c,
                p,
                f = 1,
                d = e.length,
                _ = "";

            for (n = 0; n < d; n++) {
              if ("string" == typeof e[n]) _ += e[n];else if ("object" == typeof e[n]) {
                if ((a = e[n]).keys) for (r = t[f], o = 0; o < a.keys.length; o++) {
                  if (null == r) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', a.keys[o], a.keys[o - 1]));
                  r = r[a.keys[o]];
                } else r = a.param_no ? t[a.param_no] : t[f++];
                if (i.not_type.test(a.type) && i.not_primitive.test(a.type) && r instanceof Function && (r = r()), i.numeric_arg.test(a.type) && "number" != typeof r && isNaN(r)) throw new TypeError(sprintf("[sprintf] expecting number but found %T", r));

                switch (i.number.test(a.type) && (c = r >= 0), a.type) {
                  case "b":
                    r = parseInt(r, 10).toString(2);
                    break;

                  case "c":
                    r = String.fromCharCode(parseInt(r, 10));
                    break;

                  case "d":
                  case "i":
                    r = parseInt(r, 10);
                    break;

                  case "j":
                    r = JSON.stringify(r, null, a.width ? parseInt(a.width) : 0);
                    break;

                  case "e":
                    r = a.precision ? parseFloat(r).toExponential(a.precision) : parseFloat(r).toExponential();
                    break;

                  case "f":
                    r = a.precision ? parseFloat(r).toFixed(a.precision) : parseFloat(r);
                    break;

                  case "g":
                    r = a.precision ? String(Number(r.toPrecision(a.precision))) : parseFloat(r);
                    break;

                  case "o":
                    r = (parseInt(r, 10) >>> 0).toString(8);
                    break;

                  case "s":
                    r = String(r), r = a.precision ? r.substring(0, a.precision) : r;
                    break;

                  case "t":
                    r = String(!!r), r = a.precision ? r.substring(0, a.precision) : r;
                    break;

                  case "T":
                    r = Object.prototype.toString.call(r).slice(8, -1).toLowerCase(), r = a.precision ? r.substring(0, a.precision) : r;
                    break;

                  case "u":
                    r = parseInt(r, 10) >>> 0;
                    break;

                  case "v":
                    r = r.valueOf(), r = a.precision ? r.substring(0, a.precision) : r;
                    break;

                  case "x":
                    r = (parseInt(r, 10) >>> 0).toString(16);
                    break;

                  case "X":
                    r = (parseInt(r, 10) >>> 0).toString(16).toUpperCase();
                }

                i.json.test(a.type) ? _ += r : (!i.number.test(a.type) || c && !a.sign ? p = "" : (p = c ? "+" : "-", r = r.toString().replace(i.sign, "")), u = a.pad_char ? "0" === a.pad_char ? "0" : a.pad_char.charAt(1) : " ", l = a.width - (p + r).length, s = a.width && l > 0 ? u.repeat(l) : "", _ += a.align ? p + r + s : "0" === u ? p + s + r : s + p + r);
              }
            }

            return _;
          }

          var o = Object.create(null);

          function sprintf_parse(e) {
            if (o[e]) return o[e];

            for (var t, r = e, n = [], a = 0; r;) {
              if (null !== (t = i.text.exec(r))) n.push(t[0]);else if (null !== (t = i.modulo.exec(r))) n.push("%");else {
                if (null === (t = i.placeholder.exec(r))) throw new SyntaxError("[sprintf] unexpected placeholder");

                if (t[2]) {
                  a |= 1;
                  var s = [],
                      u = t[2],
                      l = [];
                  if (null === (l = i.key.exec(u))) throw new SyntaxError("[sprintf] failed to parse named argument key");

                  for (s.push(l[1]); "" !== (u = u.substring(l[0].length));) {
                    if (null !== (l = i.key_access.exec(u))) s.push(l[1]);else {
                      if (null === (l = i.index_access.exec(u))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                      s.push(l[1]);
                    }
                  }

                  t[2] = s;
                } else a |= 2;

                if (3 === a) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                n.push({
                  placeholder: t[0],
                  param_no: t[1],
                  keys: t[2],
                  sign: t[3],
                  pad_char: t[4],
                  align: t[5],
                  width: t[6],
                  precision: t[7],
                  type: t[8]
                });
              }
              r = r.substring(t[0].length);
            }

            return o[e] = n;
          }

          t.sprintf = sprintf, t.vsprintf = vsprintf, "undefined" != typeof window && (window.sprintf = sprintf, window.vsprintf = vsprintf, void 0 === (n = function () {
            return {
              sprintf: sprintf,
              vsprintf: vsprintf
            };
          }.call(t, r, t, e)) || (e.exports = n));
        }();
      },
      462: function _(e, t, r) {
        "use strict";

        var n, i, o, a;
        r.r(t), r.d(t, {
          default: function _default() {
            return Tannin;
          }
        }), n = {
          "(": 9,
          "!": 8,
          "*": 7,
          "/": 7,
          "%": 7,
          "+": 6,
          "-": 6,
          "<": 5,
          "<=": 5,
          ">": 5,
          ">=": 5,
          "==": 4,
          "!=": 4,
          "&&": 3,
          "||": 2,
          "?": 1,
          "?:": 1
        }, i = ["(", "?"], o = {
          ")": ["("],
          ":": ["?", "?:"]
        }, a = /<=|>=|==|!=|&&|\|\||\?:|\(|!|\*|\/|%|\+|-|<|>|\?|\)|:/;
        var s = {
          "!": function _(e) {
            return !e;
          },
          "*": function _(e, t) {
            return e * t;
          },
          "/": function _(e, t) {
            return e / t;
          },
          "%": function _(e, t) {
            return e % t;
          },
          "+": function _(e, t) {
            return e + t;
          },
          "-": function _(e, t) {
            return e - t;
          },
          "<": function _(e, t) {
            return e < t;
          },
          "<=": function _(e, t) {
            return e <= t;
          },
          ">": function _(e, t) {
            return e > t;
          },
          ">=": function _(e, t) {
            return e >= t;
          },
          "==": function _(e, t) {
            return e === t;
          },
          "!=": function _(e, t) {
            return e !== t;
          },
          "&&": function _(e, t) {
            return e && t;
          },
          "||": function _(e, t) {
            return e || t;
          },
          "?:": function _(e, t, r) {
            if (e) throw t;
            return r;
          }
        };

        function compile(e) {
          var t = function postfix(e) {
            for (var t, r, s, u, l = [], c = []; t = e.match(a);) {
              for (r = t[0], (s = e.substr(0, t.index).trim()) && l.push(s); u = c.pop();) {
                if (o[r]) {
                  if (o[r][0] === u) {
                    r = o[r][1] || r;
                    break;
                  }
                } else if (i.indexOf(u) >= 0 || n[u] < n[r]) {
                  c.push(u);
                  break;
                }

                l.push(u);
              }

              o[r] || c.push(r), e = e.substr(t.index + r.length);
            }

            return (e = e.trim()) && l.push(e), l.concat(c.reverse());
          }(e);

          return function (e) {
            return function evaluate(e, t) {
              var r,
                  n,
                  i,
                  o,
                  a,
                  u,
                  l = [];

              for (r = 0; r < e.length; r++) {
                if (a = e[r], o = s[a]) {
                  for (n = o.length, i = Array(n); n--;) {
                    i[n] = l.pop();
                  }

                  try {
                    u = o.apply(null, i);
                  } catch (e) {
                    return e;
                  }
                } else u = t.hasOwnProperty(a) ? t[a] : +a;

                l.push(u);
              }

              return l[0];
            }(t, e);
          };
        }

        var u = {
          contextDelimiter: "",
          onMissingKey: null
        };

        function Tannin(e, t) {
          var r;

          for (r in this.data = e, this.pluralForms = {}, this.options = {}, u) {
            this.options[r] = void 0 !== t && r in t ? t[r] : u[r];
          }
        }

        Tannin.prototype.getPluralForm = function (e, t) {
          var r,
              n,
              i,
              o = this.pluralForms[e];
          return o || ("function" != typeof (i = (r = this.data[e][""])["Plural-Forms"] || r["plural-forms"] || r.plural_forms) && (n = function getPluralExpression(e) {
            var t, r, n;

            for (t = e.split(";"), r = 0; r < t.length; r++) {
              if (0 === (n = t[r].trim()).indexOf("plural=")) return n.substr(7);
            }
          }(r["Plural-Forms"] || r["plural-forms"] || r.plural_forms), i = function pluralForms(e) {
            var t = compile(e);
            return function (e) {
              return +t({
                n: e
              });
            };
          }(n)), o = this.pluralForms[e] = i), o(t);
        }, Tannin.prototype.dcnpgettext = function (e, t, r, n, i) {
          var o, a, s;
          return o = void 0 === i ? 0 : this.getPluralForm(e, i), a = r, t && (a = t + this.options.contextDelimiter + r), (s = this.data[e][a]) && s[o] ? s[o] : (this.options.onMissingKey && this.options.onMissingKey(r, e), 0 === o ? r : n);
        };
      },
      149: function _(e) {
        "use strict";

        e.exports = require("@wordpress/hooks");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r](i, i.exports, __webpack_require__), i.exports;
    }

    return __webpack_require__.d = function (e, t) {
      for (var r in t) {
        __webpack_require__.o(t, r) && !__webpack_require__.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__(648);
  }();
});